import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, Fragment as _Fragment, vModelText as _vModelText, withModifiers as _withModifiers, withKeys as _withKeys, withDirectives as _withDirectives, createBlock as _createBlock, renderSlot as _renderSlot, createVNode as _createVNode, normalizeStyle as _normalizeStyle, renderList as _renderList, unref as _unref, Transition as _Transition, withCtx as _withCtx, Teleport as _Teleport, resolveDirective as _resolveDirective } from "vue"

const _hoisted_1 = ["tabindex", "onKeydown"]
const _hoisted_2 = {
  key: 0,
  class: "app-select__floating-label-required"
}
const _hoisted_3 = { class: "app-select__first-value" }
const _hoisted_4 = {
  key: 0,
  class: "app-select__additional-count"
}
const _hoisted_5 = {
  key: 1,
  class: "app-select__placeholder"
}
const _hoisted_6 = {
  key: 0,
  class: "app-select__first-value"
}
const _hoisted_7 = {
  key: 1,
  class: "app-select__placeholder"
}
const _hoisted_8 = {
  key: 0,
  class: "app-select__single-value"
}
const _hoisted_9 = {
  key: 1,
  class: "app-select__placeholder"
}
const _hoisted_10 = ["placeholder", "onKeydown"]
const _hoisted_11 = ["onKeydown"]
const _hoisted_12 = {
  key: 0,
  class: "app-select__search"
}
const _hoisted_13 = { class: "app-select__controls-left" }
const _hoisted_14 = { class: "app-select__controls-right" }
const _hoisted_15 = ["disabled"]
const _hoisted_16 = { class: "app-select__options-container" }
const _hoisted_17 = { class: "app-select__options" }
const _hoisted_18 = {
  key: 0,
  class: "app-select__option app-select__option--select-all"
}
const _hoisted_19 = {
  key: 0,
  class: "app-select__group"
}
const _hoisted_20 = ["onClick", "onMouseenter"]
const _hoisted_21 = ["innerHTML"]
const _hoisted_22 = { class: "app-select__group-count" }
const _hoisted_23 = {
  key: 0,
  class: "app-select__group-children"
}
const _hoisted_24 = ["onClick", "onMouseenter"]
const _hoisted_25 = ["innerHTML"]
const _hoisted_26 = ["innerHTML"]
const _hoisted_27 = ["onClick", "onMouseenter"]
const _hoisted_28 = ["innerHTML"]
const _hoisted_29 = ["innerHTML"]
const _hoisted_30 = {
  key: 1,
  class: "app-select__empty"
}

import {
	ref,
	computed,
	watch,
	nextTick,
	onUnmounted
} from 'vue'
import AppIcon from "@/components/ui-kit/icon/AppIcon.vue";
import AppInput from "@/components/ui-kit/input/AppInput.vue";
import AppCheckbox from "@/components/ui-kit/checkbox/AppCheckbox.vue";
import { highlightSearchText } from "@/utils/textHelpers";

export interface SelectItem {
	id: string | number
	label: string
	type?: 'item' | 'group'
	disabled?: boolean
	[key: string]: any
}

export interface SelectGroup extends SelectItem {
	type: 'group'
	children: SelectItem[]
	selectable?: boolean
}

export type SelectOption = SelectItem | SelectGroup
export type SelectModelValue = string | number | (string | number)[] | null

type Props = {
	modelValue?: SelectModelValue
	items?: SelectOption[]
	multiple?: boolean
	dropdownLabel?: string
	placeholder?: string
	disabled?: boolean
	showSelectAll?: boolean
	valueKey?: string
	labelKey?: string
	displayKey?: string
	searchable?: boolean
	searchPlaceholder?: string
	closeOnSelect?: boolean
	clearable?: boolean,
	minDropdownWidth?: string | number
	dropdownHeight?: string | number
	maxDropdownHeight?: string | number
	customTriggerStyle?: any;
	customSearchStyle?: any;
	dropdownClass?: string;
	ownerChoise?: boolean
	floatingLabel?: boolean
	required?: boolean
}


export default /*@__PURE__*/_defineComponent({
  __name: 'AppSelect',
  props: {
    modelValue: { default: null },
    items: { default: () => [] },
    multiple: { type: Boolean, default: false },
    dropdownLabel: {},
    placeholder: { default: 'Выберите...' },
    disabled: { type: Boolean, default: false },
    showSelectAll: { type: Boolean, default: false },
    valueKey: { default: 'id' },
    labelKey: { default: 'label' },
    displayKey: { default: undefined },
    searchable: { type: Boolean, default: false },
    searchPlaceholder: { default: 'Поиск...' },
    closeOnSelect: { type: Boolean, default: true },
    clearable: { type: Boolean, default: false },
    minDropdownWidth: {},
    dropdownHeight: { default: undefined },
    maxDropdownHeight: { default: 400 },
    customTriggerStyle: {},
    customSearchStyle: {},
    dropdownClass: {},
    ownerChoise: { type: Boolean },
    floatingLabel: { type: Boolean, default: false },
    required: { type: Boolean, default: false }
  },
  emits: ["update:modelValue", "select", "open", "close", "search"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const isOpen = ref(false)
const isFocused = ref(false)
const focusedValue = ref<string | number | null>(null)
const searchQuery = ref('')
const triggerRef = ref<HTMLElement | null>(null)
const dropdownRef = ref<HTMLElement | null>(null)
const $searchInputRef = ref<typeof AppInput | null>(null)
const editInputRef = ref<HTMLInputElement | null>(null)
const showOnlySelected = ref(false)
const dropdownStyles = ref({})

// Проверка наличия групп
const hasGroups = computed(() => {
	return props.items.some(item => item.type === 'group')
})

// Получение всех выбираемых элементов
const selectableItems = computed(() => {
	const result: { id: string | number; label: string }[] = []

	props.items.forEach(item => {
		if (item.type === 'group') {
			item.children.forEach(child => {
				if (!child.disabled) {
					result.push({ id: child.id, label: child.label })
				}
			})
		} else {
			if (!item.disabled) {
				result.push({ id: item.id, label: item.label })
			}
		}
	})
	return result
})

// Поиск оригинальной группы для получения полного количества детей
const findOriginalGroup = (groupId: string | number) => {
	return props.items.find(item =>
		item.type === 'group' && item.id === groupId
	) as SelectGroup | undefined
}

// Фильтрация при поиске
const processedItems = computed((): SelectOption[] => {
	if (!props.searchable || !searchQuery.value) {
		return props.items.map(item => {
			if (item.type === 'group') {
				return {
					...item,
					showChildren: true
				}
			}
			return item
		})
	}

	return props.items.reduce<SelectOption[]>((acc, item) => {
		if (item.type === 'group') {
			const groupMatches = item.label.toLowerCase().includes(searchQuery.value.toLowerCase())

			if (groupMatches) {
				acc.push({
					...item,
					showChildren: true
				})
			} else {
				const matchingChildren = item.children.filter(child =>
					child.label.toLowerCase().includes(searchQuery.value.toLowerCase())
				)
				if (matchingChildren.length > 0) {
					acc.push({
						...item,
						children: matchingChildren,
						showChildren: true
					})
				}
			}
		} else {
			if (item.label.toLowerCase().includes(searchQuery.value.toLowerCase())) {
				acc.push(item)
			}
		}

		return acc
	}, [])
})

// Отфильтрованные выбираемые элементы
const filteredSelectableItems = computed(() => {
	if (!props.searchable || !searchQuery.value) {
		return selectableItems.value
	}

	return selectableItems.value.filter(item =>
		item.label.toLowerCase().includes(searchQuery.value.toLowerCase())
	)
})

// Выбранные значения
const selectedValue = computed(() => {
	if (props.multiple) return null
	return props.modelValue
})

const selectedValues = computed((): (string | number)[] => {
	if (!props.multiple) return []
	return Array.isArray(props.modelValue) ? props.modelValue : []
})

// Фильтрация по выбранным элементам
const filteredItemsWithSelected = computed((): SelectOption[] => {
	if (!showOnlySelected.value || !props.multiple) {
		return processedItems.value
	}

	return processedItems.value.reduce<SelectOption[]>((acc, item) => {
		if (item.type === 'group') {
			const selectedChildren = item.children.filter(child =>
				selectedValues.value.includes(child.id)
			)

			if (selectedChildren.length > 0) {
				acc.push({
					...item,
					children: selectedChildren,
					showChildren: item.showChildren
				})
			}
		} else {
			if (selectedValues.value.includes(item.id)) {
				acc.push(item)
			}
		}
		return acc
	}, [])
})

// Количество выбранных элементов
const selectedValuesLength = computed(() => {
	if (props.multiple) {
		return selectedValues.value.length
	}
	return selectedValue.value != null ? 1 : 0
})

const triggerPlaceholder = computed(() => (props.floatingLabel ? '' : props.placeholder))

const isLabelActive = computed(() => isOpen.value || isFocused.value || selectedValuesLength.value > 0)

// Состояние группы
const getGroupState = (group: SelectGroup) => {
	const childIds = group.children.map(child => child.id)
	const hasDisabledChildren = group.children.some(child => child.disabled)

	return {
		isSelected: childIds.length > 0 && childIds.every(id => selectedValues.value.includes(id)),
		isDisabled: group.disabled || hasDisabledChildren
	}
}

// Проверка выбран ли элемент
const isSelected = (value: string | number): boolean => {
	if (props.multiple) {
		return selectedValues.value.includes(value)
	}
	return selectedValue.value === value
}

// Получение отображаемого текста
const getDisplayValue = (value: string | number): string => {
	const label = findDisplayItem(props.items, value)
	return label || String(value)
}

const findDisplayItem = (items: SelectOption[], value: string | number): string | undefined => {
	for (const item of items) {
		if (item.type === 'group') {
			if (item.id === value) return item.label
			const found = item.children.find(child => child.id === value)
			if (found) return found.label
		} else {
			if (item.id === value) return item.label
		}
	}
	return undefined
}

// Элементы для отображения в триггере
const selectedDisplayItems = computed(() => {
	return selectedValues.value.map(id => ({
		id,
		label: getDisplayValue(id)
	}))
})

// Проверка выбраны ли все
const isAllSelected = computed((): boolean => {
	if (!props.multiple) return false
	return selectableItems.value.length > 0 &&
		selectableItems.value.every(item => selectedValues.value.includes(item.id))
})

// Обновление позиции дропдауна
const updateDropdownPosition = () => {
	if (!triggerRef.value || !isOpen.value) return

	const rect = triggerRef.value.getBoundingClientRect()
	const viewportHeight = window.innerHeight
	const spaceBelow = viewportHeight - rect.bottom
	const spaceAbove = rect.top

	// Определяем направление открытия
	let openUp = false
	if (props.dropdownHeight === undefined) {
		// При динамической высоте используем старую логику
		openUp = spaceBelow < 300 && spaceAbove > spaceBelow
	} else {
		// При фиксированной высоте тоже можно определять направление,
		// чтобы дропдаун не выходил за экран по вертикали
		openUp = spaceBelow < (typeof props.dropdownHeight === 'number' ? props.dropdownHeight : parseFloat(props.dropdownHeight)) && spaceAbove > spaceBelow
	}

	// Вычисляем ширину (без изменений)
	let width = `${rect.width}px`
	if (props.minDropdownWidth) {
		const minWidth = typeof props.minDropdownWidth === 'number'
			? `${props.minDropdownWidth}px`
			: props.minDropdownWidth
		width = `max(${minWidth}, ${rect.width}px)`
	}

	// Базовые стили позиционирования
	const styles: any = {
		position: 'fixed',
		top: openUp ? 'auto' : `${rect.bottom + 4}px`,
		bottom: openUp ? `${viewportHeight - rect.top + 4}px` : 'auto',
		left: `${rect.left}px`,
		width: width,
		minWidth: props.minDropdownWidth ? `${rect.width}px` : 'auto',
		zIndex: 10001
	}

	if (props.dropdownHeight !== undefined) {
		// Фиксированная высота
		const heightValue = typeof props.dropdownHeight === 'number'
			? `${props.dropdownHeight}px`
			: props.dropdownHeight
		styles.height = heightValue
		// Убираем maxHeight, чтобы не конфликтовать
		styles.maxHeight = 'none'
	} else {
		// Динамическая высота
		const availableHeight = openUp ? spaceAbove - 20 : spaceBelow - 20
		let maxH = Math.max(100, availableHeight)
		if (props.maxDropdownHeight !== undefined) {
			const limit = typeof props.maxDropdownHeight === 'number'
				? props.maxDropdownHeight
				: parseFloat(props.maxDropdownHeight)
			if (!Number.isNaN(limit)) {
				maxH = Math.min(maxH, limit)
			}
		}
		styles.maxHeight = `${maxH}px`
	}

	dropdownStyles.value = styles
}

// const minTriggerHeight =computed(() => {
// 	const styles: any = {
// 		minHeight:`32px`,
// 	}

// 	if (props.minTriggerHeight !== 32) {
// 		styles.minHeight = `${typeof props.minTriggerHeight === 'number'
// 			? props.minTriggerHeight
// 			: parseFloat(props.minTriggerHeight)}px`
// 	}

// 	return styles;
// });

// Сброс выбора
const resetSelection = (): void => {
	if (!props.multiple) return

	emit('update:modelValue', [])
	emit('select', [])
}

const toggleShowOnlySelected = (value: boolean) => {
	showOnlySelected.value = value
}

// Очистка значения
const handleClear = () => {
	if (props.multiple) {
		emit('update:modelValue', [])
		emit('select', [])
	} else {
		emit('update:modelValue', null)
		emit('select', null)
	}
}

// Обработка клика по триггеру
const handleTriggerClick = () => {
	if (props.disabled) return

	toggleDropdown()
}

// Обработка Enter на триггере
const handleTriggerEnter = (): void => {
	if (props.disabled) return

	if (!isOpen.value) {
		toggleDropdown()
	} else {
		nextTick(() => {
			if (dropdownRef.value) {
				dropdownRef.value.focus()
			}
		})
	}
}

// Обработка Enter в поиске
const handleSearchEnter = () => {
	if (!isOpen.value) return;

	if (focusedValue.value) {
		const isInList = filteredSelectableItems.value.some(
			item => item.id === focusedValue.value
		);

		if (isInList) {
			handleSelect(focusedValue.value);
			closeDropdown();
			return;
		}
	}

	const firstItem = filteredSelectableItems.value[0];
	if (firstItem) {
		handleSelect(firstItem.id);
		closeDropdown();
	}
};

// Обработка Enter в дропдауне
const handleDropdownEnter = (): void => {
	if (!isOpen.value || !focusedValue.value) return

	const isInFilteredList = filteredSelectableItems.value.some(
		item => item.id === focusedValue.value
	)

	if (!isInFilteredList) return

	const item = findEnterPressedItem(processedItems.value)
	if (item && !item.disabled) {
		if (item.type !== 'group') {
			handleSelect(item.id)
		}
	}
}

const findEnterPressedItem = (items: SelectOption[]): SelectItem | undefined => {
	for (const item of items) {
		if (item.type === 'group') {
			if (item.id === focusedValue.value) {
				if (props.multiple && (item as SelectGroup).selectable) {
					toggleGroupSelection(item as SelectGroup)
					return undefined
				}
				return undefined
			}
			const found = item.children.find(child => child.id === focusedValue.value)
			if (found) return found
		} else {
			if (item.id === focusedValue.value) return item
		}
	}
	return undefined
}

// Обработка клавиш на триггере
const handleTriggerKeyDown = (event: KeyboardEvent): void => {
	if (!isOpen.value) {
		if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
			event.preventDefault()
			toggleDropdown()
		}
	}
}

// Обработка клавиш в дропдауне
const handleDropdownKeyDown = (event: KeyboardEvent): void => {
	if (!isOpen.value || !filteredSelectableItems.value.length) return

	const currentIndex = filteredSelectableItems.value.findIndex(
		item => item.id === focusedValue.value
	)

	let newIndex: number

	switch (event.key) {
		case 'ArrowDown':
			event.preventDefault()
			newIndex = currentIndex < filteredSelectableItems.value.length - 1 ? currentIndex + 1 : 0
			focusedValue.value = filteredSelectableItems.value[newIndex].id
			nextTick(() => scrollToFocused())
			break

		case 'ArrowUp':
			event.preventDefault()
			newIndex = currentIndex > 0 ? currentIndex - 1 : filteredSelectableItems.value.length - 1
			focusedValue.value = filteredSelectableItems.value[newIndex].id
			nextTick(() => scrollToFocused())
			break
	}
}

// Обработка выбора элемента
const handleSelect = (value: string | number, event?: Event): void => {
	if (props.disabled) return

	if (event) {
		event.stopPropagation()
	}

	let newValue: SelectModelValue

	if (props.multiple) {
		const values = [...selectedValues.value]
		const index = values.indexOf(value)

		if (index === -1) {
			values.push(value)
		} else {
			values.splice(index, 1)
		}

		newValue = values
	} else {
		newValue = value
		if (props.closeOnSelect) {
			setTimeout(() => {
				isOpen.value = false
				emit('close')
			}, 100)
		}
	}

	emit('update:modelValue', newValue)
	emit('select', newValue)

	if (props.searchable && !props.multiple) {
		searchQuery.value = ''
	}
}

// Обработка клика по элементу
const handleItemClick = (item: SelectItem): void => {
	if (item.disabled || item.type === 'group') return

	if (!props.multiple) {
		handleSelect(item.id)
	}
}

// Переключение выбора группы
const toggleGroupSelection = (group: SelectGroup): void => {
	if (!props.multiple || group.selectable === false || group.disabled) return

	const originalGroup = findOriginalGroup(group.id)
	if (!originalGroup) return

	const childIds = originalGroup.children
		.filter(child => !child.disabled)
		.map(child => child.id)

	const state = getGroupState(originalGroup)
	const currentValues = [...selectedValues.value]

	let newValues: (string | number)[]

	if (state.isSelected) {
		newValues = currentValues.filter(id => !childIds.includes(id))
	} else {
		newValues = [...currentValues]
		childIds.forEach(id => {
			if (!newValues.includes(id)) {
				newValues.push(id)
			}
		})
	}

	emit('update:modelValue', newValues)
	emit('select', newValues)

	if (props.searchable && props.multiple) {
		searchQuery.value = ''
		const firstSelectable = filteredSelectableItems.value[0]
		focusedValue.value = firstSelectable?.id || null
	}
}

// Выбрать все
const toggleAll = (): void => {
	if (!props.multiple) return

	if (isAllSelected.value) {
		emit('update:modelValue', [])
		emit('select', [])
	} else {
		emit('update:modelValue', selectableItems.value.map(item => item.id))
		emit('select', selectableItems.value.map(item => item.id))
	}

	if (props.searchable && props.multiple) {
		searchQuery.value = ''
		const firstSelectable = filteredSelectableItems.value[0]
		focusedValue.value = firstSelectable?.id || null
	}
}

// Переключение дропдауна
const toggleDropdown = (): void => {
	if (props.disabled) return

	isOpen.value = !isOpen.value

	if (isOpen.value) {
		emit('open')
		updateDropdownPosition()

		const firstSelectable = filteredSelectableItems.value[0]
		focusedValue.value = firstSelectable?.id || null

		nextTick(() => {
			if (props.searchable) {
				if ((props.multiple || props.ownerChoise) && $searchInputRef.value) {
					$searchInputRef.value.focusInput()
				} else if (!props.multiple && editInputRef.value) {
					editInputRef.value.focus()
				}
			} else if (dropdownRef.value) {
				dropdownRef.value.focus()
			}
		})
	} else {
		emit('close')
		if (props.multiple) {
			searchQuery.value = ''
		}
	}
}

// Закрытие дропдауна
const closeDropdown = (): void => {
	if (isOpen.value) {
		isOpen.value = false
		emit('close')
		if (!props.multiple) {
			searchQuery.value = ''
		}
		// triggerRef.value?.focus()
		triggerRef.value?.blur()
	}
}

// Скролл к фокусированному элементу
const scrollToFocused = (): void => {
	if (!dropdownRef.value || !focusedValue.value) return

	const focusedElement = dropdownRef.value.querySelector(
		'.app-select__option--focused, .app-select__group-header--focused'
	) as HTMLElement

	if (focusedElement) {
		focusedElement.scrollIntoView({
			block: 'center',
			behavior: 'smooth'
		})
	}
}

// Обработка Escape
const handleEscape = (event: KeyboardEvent) => {
	if (event.key === 'Escape') {
		event.preventDefault()
		event.stopPropagation()
		if (isOpen.value) {
			closeDropdown()
		}
	}
}

watch(searchQuery, (value) => {
	emit('search', value)
	const firstSelectable = filteredSelectableItems.value[0]
	focusedValue.value = firstSelectable?.id || null
})

const handleClickOutside = (e: MouseEvent) => {
  const target = e.target as Node
  if (
    triggerRef.value?.contains(target) ||
    dropdownRef.value?.contains(target)
  ) return
  closeDropdown()
}

watch(isOpen, (newVal) => {
	if (newVal) {
		// document.addEventListener('mousedown', handleClickOutside)
		document.addEventListener('keydown', handleEscape, { capture: true })
		window.addEventListener('scroll', updateDropdownPosition, true)
		window.addEventListener('resize', updateDropdownPosition)
	} else {
		// document.removeEventListener('mousedown', handleClickOutside)
		document.removeEventListener('keydown', handleEscape, { capture: true })
		window.removeEventListener('scroll', updateDropdownPosition, true)
		window.removeEventListener('resize', updateDropdownPosition)
		showOnlySelected.value = false
		if (props.multiple) {
			searchQuery.value = ''
		}
	}
})

onUnmounted(() => {
	document.removeEventListener('keydown', handleEscape, { capture: true })
	window.removeEventListener('scroll', updateDropdownPosition, true)
	window.removeEventListener('resize', updateDropdownPosition)
})

return (_ctx: any,_cache: any) => {
  const _directive_click_outside = _resolveDirective("click-outside")!

  return _withDirectives((_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["app-select", {
			'app-select--open': isOpen.value,
			'app-select--disabled': _ctx.disabled,
			'app-select--multiple': _ctx.multiple,
			'app-select--focused': isFocused.value,
			'app-select--has-groups': hasGroups.value,
			'app-select--searchable': _ctx.searchable && !_ctx.multiple && !_ctx.ownerChoise,
			'app-select--clearable': _ctx.clearable
		}])
  }, [
    _createElementVNode("div", {
      ref_key: "triggerRef",
      ref: triggerRef,
      class: _normalizeClass(["app-select__trigger", {
				'app-select__trigger--editable': _ctx.searchable && !_ctx.multiple && !_ctx.ownerChoise && isOpen.value
			}]),
      style: _normalizeStyle(_ctx.customTriggerStyle),
      tabindex: _ctx.disabled ? -1 : 0,
      onClick: handleTriggerClick,
      onKeydown: [
        _withKeys(_withModifiers(handleTriggerEnter, ["prevent"]), ["enter"]),
        _withKeys(closeDropdown, ["esc"]),
        _withKeys(_withModifiers(handleTriggerKeyDown, ["prevent"]), ["down"]),
        _withKeys(_withModifiers(handleTriggerKeyDown, ["prevent"]), ["up"])
      ],
      onFocus: _cache[3] || (_cache[3] = ($event: any) => (isFocused.value = true)),
      onBlur: _cache[4] || (_cache[4] = ($event: any) => (isFocused.value = false))
    }, [
      (_ctx.floatingLabel && _ctx.placeholder)
        ? (_openBlock(), _createElementBlock("label", {
            key: 0,
            class: _normalizeClass({
					'app-select__floating-label': true,
					active: isLabelActive.value
				})
          }, [
            _createTextVNode(_toDisplayString(_ctx.placeholder) + " ", 1),
            (_ctx.required)
              ? (_openBlock(), _createElementBlock("span", _hoisted_2, "*"))
              : _createCommentVNode("", true)
          ], 2))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: _normalizeClass(["app-select__values", {
					'app-select__values--hidden': _ctx.searchable && !_ctx.multiple && !_ctx.ownerChoise && isOpen.value
				}])
      }, [
        (_ctx.multiple && _ctx.dropdownLabel==undefined)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              (selectedDisplayItems.value.length)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createElementVNode("span", _hoisted_3, _toDisplayString(selectedDisplayItems.value[0].label), 1),
                    (selectedDisplayItems.value.length > 1)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_4, " +" + _toDisplayString(selectedDisplayItems.value.length - 1), 1))
                      : _createCommentVNode("", true)
                  ], 64))
                : (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(triggerPlaceholder.value), 1))
            ], 64))
          : (_ctx.dropdownLabel)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                (selectedDisplayItems.value.length)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.dropdownLabel), 1))
                  : (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(triggerPlaceholder.value), 1))
              ], 64))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                (selectedValue.value != null)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(getDisplayValue(selectedValue.value)), 1))
                  : (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(triggerPlaceholder.value), 1))
              ], 64))
      ], 2),
      (_ctx.searchable && !_ctx.multiple && !_ctx.ownerChoise && isOpen.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: "app-select__edit-container",
            onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
          }, [
            _withDirectives(_createElementVNode("input", {
              ref_key: "editInputRef",
              ref: editInputRef,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchQuery).value = $event)),
              class: "app-select__edit-input",
              placeholder: _ctx.searchPlaceholder,
              onKeydown: [
                _withKeys(_withModifiers(handleSearchEnter, ["prevent"]), ["enter"]),
                _withKeys(_withModifiers(handleDropdownKeyDown, ["prevent"]), ["down"]),
                _withKeys(_withModifiers(handleDropdownKeyDown, ["prevent"]), ["up"])
              ]
            }, null, 40, _hoisted_10), [
              [_vModelText, searchQuery.value]
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: "app-select__actions",
        onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"]))
      }, [
        (_ctx.clearable && selectedValuesLength.value > 0)
          ? (_openBlock(), _createBlock(AppIcon, {
              key: 0,
              class: "app-select__clear-button",
              name: "arrow-left",
              width: "16px",
              color: "#979797",
              onClick: _withModifiers(handleClear, ["stop"])
            }))
          : _createCommentVNode("", true),
        _renderSlot(_ctx.$slots, "append-icon", { close: closeDropdown }, () => [
          _createVNode(AppIcon, {
            class: "app-select__arrow",
            name: "chevron-down",
            width: "16px",
            color: "#979797",
            cursor: "pointer",
            onClick: _withModifiers(toggleDropdown, ["stop"])
          })
        ])
      ])
    ], 46, _hoisted_1),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      _createVNode(_Transition, { name: "select-dropdown" }, {
        default: _withCtx(() => [
          (isOpen.value)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass([
						'app-select__dropdown',
						_ctx.dropdownClass,
						{ 'app-select__dropdown--single': !_ctx.multiple }
					]),
                style: _normalizeStyle(dropdownStyles.value),
                ref_key: "dropdownRef",
                ref: dropdownRef,
                onKeydown: [
                  _withKeys(_withModifiers(handleDropdownEnter, ["prevent"]), ["enter"]),
                  _withKeys(closeDropdown, ["esc"]),
                  _withKeys(_withModifiers(handleDropdownKeyDown, ["prevent"]), ["down"]),
                  _withKeys(_withModifiers(handleDropdownKeyDown, ["prevent"]), ["up"])
                ]
              }, [
                _createElementVNode("div", {
                  style: _normalizeStyle(_ctx.customSearchStyle)
                }, [
                  (_ctx.searchable && (_ctx.multiple || _ctx.ownerChoise))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                        _createVNode(AppInput, {
                          ref_key: "$searchInputRef",
                          ref: $searchInputRef,
                          modelValue: searchQuery.value,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((searchQuery).value = $event)),
                          class: "app-select__search-input",
                          placeholder: _ctx.searchPlaceholder,
                          "show-search-button": "",
                          onClick: _cache[6] || (_cache[6] = _withModifiers(() => {}, ["stop"]))
                        }, null, 8, ["modelValue", "placeholder"])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.multiple)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 1,
                        class: "app-select__controls",
                        onClick: _cache[8] || (_cache[8] = _withModifiers(() => {}, ["stop"]))
                      }, [
                        _createElementVNode("div", _hoisted_13, [
                          _createVNode(AppCheckbox, {
                            value: showOnlySelected.value,
                            onOnInput: toggleShowOnlySelected,
                            onClick: _cache[7] || (_cache[7] = _withModifiers(() => {}, ["stop"]))
                          }, null, 8, ["value"]),
                          _cache[13] || (_cache[13] = _createElementVNode("span", { class: "app-select__controls-text" }, "Показать выбранных", -1))
                        ]),
                        _createElementVNode("div", _hoisted_14, [
                          _createElementVNode("button", {
                            class: "app-select__reset-button",
                            onClick: _withModifiers(resetSelection, ["stop"]),
                            disabled: !selectedValues.value.length
                          }, " Сбросить ", 8, _hoisted_15)
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ], 4),
                _createElementVNode("div", _hoisted_16, [
                  _renderSlot(_ctx.$slots, "dropdown", {
                    items: filteredItemsWithSelected.value,
                    selected: selectedValues.value,
                    select: handleSelect,
                    getGroupState: getGroupState,
                    close: closeDropdown,
                    search: searchQuery.value
                  }, () => [
                    _createElementVNode("div", _hoisted_17, [
                      (_ctx.multiple && _ctx.showSelectAll && selectableItems.value.length)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                            _createElementVNode("div", {
                              class: "app-select__option-label",
                              onClick: _cache[9] || (_cache[9] = _withModifiers(() => {}, ["stop"]))
                            }, [
                              _createVNode(AppCheckbox, {
                                value: isAllSelected.value,
                                onOnInput: toggleAll
                              }, null, 8, ["value"]),
                              _cache[14] || (_cache[14] = _createElementVNode("span", {
                                class: "app-select__group-title",
                                style: { fontWeight: '400' }
                              }, " Все пользователи ", -1))
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredItemsWithSelected.value, (item) => {
                        return (_openBlock(), _createElementBlock(_Fragment, {
                          key: String(item.id)
                        }, [
                          (item.type === 'group')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                _createElementVNode("div", {
                                  class: _normalizeClass(["app-select__group-header", {
												'app-select__group-header--selectable': _ctx.multiple && item.selectable !== false,
												'app-select__group-header--disabled': item.disabled,
												'app-select__group-header--focused': focusedValue.value === item.id
											}]),
                                  onClick: _withModifiers(($event: any) => (toggleGroupSelection(item)), ["stop"]),
                                  onMouseenter: ($event: any) => (focusedValue.value = item.id)
                                }, [
                                  (_ctx.multiple && item.selectable !== false)
                                    ? (_openBlock(), _createElementBlock("label", {
                                        key: 0,
                                        class: "app-select__group-checkbox",
                                        onClick: _cache[10] || (_cache[10] = _withModifiers(() => {}, ["stop"]))
                                      }, [
                                        _createVNode(AppCheckbox, {
                                          value: getGroupState(item).isSelected,
                                          disabled: item.disabled,
                                          onOnInput: ($event: any) => (toggleGroupSelection(item))
                                        }, null, 8, ["value", "disabled", "onOnInput"])
                                      ]))
                                    : _createCommentVNode("", true),
                                  _createElementVNode("span", {
                                    class: "app-select__group-title",
                                    innerHTML: _unref(highlightSearchText)(searchQuery.value, item.label)
                                  }, null, 8, _hoisted_21),
                                  _createElementVNode("span", _hoisted_22, " (" + _toDisplayString(findOriginalGroup(item.id)?.children.length || item.children.length) + ") ", 1)
                                ], 42, _hoisted_20),
                                (item.showChildren)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.children, (child) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                          key: String(child.id),
                                          class: _normalizeClass(["app-select__option app-select__option--child", {
													'app-select__option--disabled': child.disabled,
													'app-select__option--focused': focusedValue.value === child.id
												}]),
                                          onClick: ($event: any) => (handleItemClick(child)),
                                          onMouseenter: ($event: any) => (focusedValue.value = child.id)
                                        }, [
                                          (_ctx.multiple)
                                            ? (_openBlock(), _createElementBlock("label", {
                                                key: 0,
                                                class: "app-select__option-label",
                                                onClick: _cache[11] || (_cache[11] = _withModifiers(() => {}, ["stop"]))
                                              }, [
                                                _createVNode(AppCheckbox, {
                                                  value: isSelected(child.id),
                                                  disabled: child.disabled,
                                                  onOnChange: ($event: any) => (handleSelect(child.id, $event))
                                                }, null, 8, ["value", "disabled", "onOnChange"]),
                                                _createElementVNode("span", {
                                                  innerHTML: _unref(highlightSearchText)(searchQuery.value, child.label)
                                                }, null, 8, _hoisted_25)
                                              ]))
                                            : (_openBlock(), _createElementBlock("span", {
                                                key: 1,
                                                innerHTML: _unref(highlightSearchText)(searchQuery.value, child.label)
                                              }, null, 8, _hoisted_26))
                                        ], 42, _hoisted_24))
                                      }), 128))
                                    ]))
                                  : _createCommentVNode("", true)
                              ]))
                            : (_openBlock(), _createElementBlock("div", {
                                key: 1,
                                class: _normalizeClass(["app-select__option", {
											'app-select__option--selected': isSelected(item.id),
											'app-select__option--disabled': item.disabled,
											'app-select__option--focused': focusedValue.value === item.id
										}]),
                                onClick: ($event: any) => (handleItemClick(item)),
                                onMouseenter: ($event: any) => (focusedValue.value = item.id)
                              }, [
                                (_ctx.multiple)
                                  ? (_openBlock(), _createElementBlock("label", {
                                      key: 0,
                                      class: "app-select__option-label",
                                      onClick: _cache[12] || (_cache[12] = _withModifiers(() => {}, ["stop"]))
                                    }, [
                                      _createVNode(AppCheckbox, {
                                        value: isSelected(item.id),
                                        disabled: item.disabled,
                                        onOnChange: ($event: any) => (handleSelect(item.id, $event))
                                      }, null, 8, ["value", "disabled", "onOnChange"]),
                                      _createElementVNode("span", {
                                        innerHTML: _unref(highlightSearchText)(searchQuery.value, item.label)
                                      }, null, 8, _hoisted_28)
                                    ]))
                                  : (_openBlock(), _createElementBlock("span", {
                                      key: 1,
                                      innerHTML: _unref(highlightSearchText)(searchQuery.value, item.label)
                                    }, null, 8, _hoisted_29))
                              ], 42, _hoisted_27))
                        ], 64))
                      }), 128)),
                      (!filteredItemsWithSelected.value.length)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_30, _toDisplayString(searchQuery.value ? 'Подходящих пользователей не найдено' : showOnlySelected.value ? 'Нет выбранных пользователей' : 'Нет данных'), 1))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ])
              ], 46, _hoisted_11))
            : _createCommentVNode("", true)
        ]),
        _: 3
      })
    ]))
  ], 2)), [
    [_directive_click_outside, closeDropdown]
  ])
}
}

})